/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner } from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner';
import {
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSON,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSONTyped,
    MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSON,
} from './MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner';

/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata
 */
export interface MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    /**
     * 
     * @type {Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner>}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata
     */
    related_document_information?: Array<MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInner>;
    /**
     * Reason for the error (used with PROCESSING_ERROR type)
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata
     */
    reason?: string;
    /**
     * Human-readable error message (used with PROCESSING_ERROR type)
     * @type {string}
     * @memberof MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata
     */
    message?: string;
}

/**
 * Check if a given object implements the MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata interface.
 */
export function instanceOfMatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSON(json: any): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    return MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'related_document_information': !exists(json, 'related_document_information') ? undefined : ((json['related_document_information'] as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerFromJSON)),
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataToJSON(value?: MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'related_document_information': value.related_document_information === undefined ? undefined : ((value.related_document_information as Array<any>).map(MatrixCarePatientDetailsDocumentsScreenerDocumentsInnerErrorsInnerMetadataRelatedDocumentInformationInnerToJSON)),
        'reason': value.reason,
        'message': value.message,
    };
}

